export default "__VITE_ASSET__CH9NRPbA__"